module.exports = __webpack_public_path__ + "img/renault-twingo.9179f866.jpg";